import { setupNotificationsUsageTracker } from './NotificationTracker';
import { isJasmineRunning } from './utils/testEnv';
const initializeUsageTrackers = () => {
  if (!isJasmineRunning()) {
    setupNotificationsUsageTracker();
  }
};
export default initializeUsageTrackers;